module.exports = __webpack_public_path__ + "static/img/公司2.590426b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/公司2.jpg
// module id = 6YpI
// module chunks = 1